import React from "react";
import { FlyerTemplateIconProps } from "./flyer-detail-add-page-template-option-icon.props";
import { HostContainer } from "./flyer-detail-add-page-template-option-icon.styles";

export const FlyerDetailAddPageTemplateOptionIcon = (props: FlyerTemplateIconProps) => {
  const hasPreview = () => Boolean(props.previewImageUrl && props.previewImageUrl.length);

  return (
    <HostContainer className={props.className}>
      {hasPreview() && <img src={props.previewImageUrl} alt="Template Preview" />}
    </HostContainer>
  );
};
